import { Injectable } from '@angular/core';
import { Http, RootContext, Wrapper } from '@skylab-angular-shared/core';
import { AnnouncementsNotificatorBase } from '@skylab-shared/business';
import { ViewSettingsRepository } from '../../view-settings/view-settings.repo';
import { EventNotificationsService } from '../event-notifications.service';

@Injectable({ providedIn: 'root'})
@Wrapper(AnnouncementsNotificatorBase)
export class AnnouncementsNotificator {
    public constructor(
        rootContext: RootContext,
        viewSettingsRepo: ViewSettingsRepository,
        eventNortifications: EventNotificationsService,
        http: Http
    ) { }
}
